import { useEffect } from 'react';

import { useAppKindContext } from '@Components/root';
import { CategoryKind } from '@Graphql/graphqlTypes.generated';

export const useSetAppKind = (appKind: CategoryKind | undefined) => {
  const { setAppKind } = useAppKindContext();

  useEffect(() => {
    setAppKind(appKind || CategoryKind.Agro);
  }, [appKind]);
};
